import React from "react";
import { Link } from "react-router-dom";
import SvgIcon from "../../components/SvgIcon/SvgIcon";
import { IconName } from "../../assets/icons";
import { ButtonVariant, buttonColors } from "../../styles/buttonColors";

interface ButtonCustomProps {
  text: string;
  to?: string;
  onClick?: () => void;
  iconKey?: IconName;
  variant?: ButtonVariant;
  size?: "xs" | "sm" | "md" | "lg";
  rounded?: "none" | "md" | "full";
  outline?: boolean;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  fullWidthMobile?: boolean; // 🔥 NUEVO
  /** Ancho completo siempre (no solo en mobile) — ej. CTA de formularios centrados. */
  fullWidth?: boolean;
}

const ButtonCustom: React.FC<ButtonCustomProps> = ({
  text,
  to,
  onClick,
  iconKey,
  variant = "primary",
  size = "md",
  rounded = "md",
  outline = false,
  type = "button",
  disabled = false,
  fullWidthMobile = false,
  fullWidth = false,
}) => {
  // 📏 Tamaños RESPONSIVE
  const sizes: Record<string, string> = {
    xs: "px-2 py-1 text-xs gap-1",
    sm: "px-3 py-2 text-sm gap-1.5",
    md: "px-4 py-2 text-sm sm:px-6 sm:py-3 sm:text-base",
    lg: "px-6 py-3 text-base sm:px-10 sm:py-4 sm:text-lg",
  };

  // 🔹 Tamaño de icono dinámico
  const iconSizes: Record<string, string> = {
    xs: "h-3 w-3",
    sm: "h-4 w-4",
    md: "h-4 w-4 sm:h-5 sm:w-5",
    lg: "h-5 w-5 sm:h-6 sm:w-6",
  };

  // ⭕ Bordes
  const radius: Record<string, string> = {
    none: "",
    md: "rounded-md",
    full: "rounded-full",
  };

  // 🎨 Estilos
  const variantStyles = outline
    ? buttonColors[variant].outline
    : buttonColors[variant].solid;

  // 🚫 Disabled
  const disabledStyles =
    "opacity-50 cursor-not-allowed hover:bg-opacity-100 hover:opacity-50";

  // 📱 Ancho: completo siempre, solo en mobile, o auto
  const responsiveWidth = fullWidth
    ? "w-full"
    : fullWidthMobile
      ? "w-full sm:w-auto"
      : "";

  const classes = `
    inline-flex items-center justify-center
    font-medium shadow-sm transition
    ${variantStyles}
    ${sizes[size]}
    ${radius[rounded]}
    ${responsiveWidth}
    ${disabled ? disabledStyles : "hover:bg-opacity-90"}
  `;

  const content = (
  <>
    {iconKey && (
      <SvgIcon
        name={iconKey}
        className={`${iconSizes[size]} shrink-0 mr-1`}
      />
    )}
    <span className="whitespace-nowrap">{text}</span>
  </>
);

  return to && !disabled ? (
    <Link to={to} className={classes}>
      {content}
    </Link>
  ) : (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={classes}
    >
      {content}
    </button>
  );
};

export default ButtonCustom;